import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Battle = makeShortcode("Battle");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler II Hikari Single Story" mdxType="SEO" />
    <h5 {...{
      "id": "battle-1"
    }}>{`Battle 1`}</h5>
    <p>{`Attack x2 with both`}</p>
    <h5 {...{
      "id": "battle-2"
    }}>{`Battle 2`}</h5>
    <ul>
      <li parentName="ul">{`Hikari: Attack x2 Officer`}</li>
      <li parentName="ul">{`Ritsu: Wild Cut x2 Officer`}</li>
      <li parentName="ul">{`Rai Mei: Sweep x2`}</li>
    </ul>
    <h5 {...{
      "id": "battle-3"
    }}>{`Battle 3`}</h5>
    <h6 {...{
      "id": "t1"
    }}>{`T1`}</h6>
    <ul>
      <li parentName="ul">{`Hikari: Attack x2 General`}</li>
      <li parentName="ul">{`Ritsu: Wild Cut x2 General`}</li>
      <li parentName="ul">{`Rai Mei: Sweep`}</li>
    </ul>
    <h6 {...{
      "id": "t2"
    }}>{`T2`}</h6>
    <ul>
      <li parentName="ul">{`Hikari: Attack General`}</li>
      <li parentName="ul">{`Ritsu: Attack General`}</li>
      <li parentName="ul">{`Rai Mei: Sweep x3`}</li>
    </ul>
    <p>{`Note if you got a Wind S drop.`}</p>
    <p>{`Challenge: Aggressive Slash x2, Attack (Hachimongiri if miss)`}<br parentName="p"></br>{`
`}{`Learn `}<strong parentName="p">{`Double Slash`}</strong>{`. `}<em parentName="p">{`Can skip if you have Wind S`}</em><br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1600`}</strong>{` before Bribe.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Fire S`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ritsu-1850hp-5s-sword-bow-fire"
      }}>{`Ritsu 1850HP 5S (Sword Bow Fire)`}</h4>
      <ol>
        <li parentName="ol">{`Fire S`}</li>
        <li parentName="ol">{`Wind S`}</li>
        <li parentName="ol">{`Aggressive Slash`}</li>
        <li parentName="ol">{`Attack`}</li>
        <li parentName="ol">{`Piercing Thrust x4`}</li>
        <li parentName="ol">{`Attack`}</li>
        <li parentName="ol">{`Defend`}</li>
        <li parentName="ol">{`Attack`}</li>
        <li parentName="ol">{`Aggressive Slash x2/3`}</li>
        <li parentName="ol">{`Hienka x3/4`}</li>
      </ol>
      <hr></hr>
      <h4 {...{
        "id": "no-wind-s"
      }}>{`No Wind S`}</h4>
      <ol>
        <li parentName="ol">{`Attack Ritsu's Footman (Up)`}</li>
        <li parentName="ol">{`Fire S`}</li>
        <li parentName="ol">{`Hachimongiri x2 Ritsu's Footman`}</li>
        <li parentName="ol">{`Double Slash`}</li>
        <li parentName="ol">{`Attack (x2 if miss)`}</li>
        <li parentName="ol">{`Double Slash`}</li>
        <li parentName="ol">{`Piercing Thrust x4`}</li>
        <li parentName="ol">{`Aggressive Slash x2 (no boost if miss)`}</li>
        <li parentName="ol">{`Attack (If only 1 shield or Ritsu before you next turn and can kill you, Defend. Can also Heal)`}</li>
        <li parentName="ol">{`Defend`}</li>
        <li parentName="ol">{`Attack (Break) / Defend if 2 Shields left and Attack x2 next turn`}</li>
        <li parentName="ol">{`Hienka x4`}</li>
      </ol>
    </Battle>
    <p>{`Go to Oresrush`}</p>
    <h3 {...{
      "id": "oresrush"
    }}>{`Oresrush`}</h3>
    <p>{`Get Partitio. Go towards Crackridge Harbor.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1600`}</strong>{`. Tag `}<strong parentName="p">{`Anchorage`}</strong>{`, TP `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush-1"
    }}>{`Oresrush`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Unerring Earring`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can try to get all Conoct ingredients at Black Market instead of shops. If you do, skip all Conoct shops.`}</p>
    </blockquote>
    <p>{`Go to Item Shop, buy `}<strong parentName="p">{`3 Darkdelion`}</strong>{`. Hire guy for `}<strong parentName="p">{`Smooth Talker`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Crackridge Anchorage`}</strong>{`, take boat to `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-anchorage"
    }}>{`New Delsta Anchorage`}</h3>
    <p>{`Tag `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Walk to `}<strong parentName="p">{`Cape Cold`}</strong>{` area.`}<br parentName="p"></br>{`
`}{`Walk to & get `}<strong parentName="p">{`Oswald`}</strong><br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Cape Cold`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cape-cold"
    }}>{`Cape Cold`}</h3>
    <p>{`Mug: Icewind, Fireball x3`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$2000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`. Take boat to `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Buy `}<strong parentName="p">{`White Powder`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Get Castti.`}<br parentName="p"></br>{`
`}{`Turn in quest.`}<br parentName="p"></br>{`
`}{`Go to Item Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`11 Lily of the Light`}</li>
      </ul>
    </Menu>
    <p>{`Go to Weapon Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Crit Earring`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
        <li parentName="ul">{`Crit M`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Abandoned Village`}</strong>{`.`}</p>
    <h3 {...{
      "id": "abandoned-village"
    }}>{`Abandoned Village`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Black Market`}</strong>{`. Pick `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get Cleric, then:`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <p>{`1 Fire S`}<br parentName="p"></br>{`
`}{`1 Ice S`}<br parentName="p"></br>{`
`}{`1 Thunder S`}<br parentName="p"></br>{`
`}{`1 Fire M`}<br parentName="p"></br>{`
`}{`1 Ice M`}<br parentName="p"></br>{`
`}<strong parentName="p">{`7`}</strong>{` Shadow M`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Ryu`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ryu"
    }}>{`Ryu`}</h3>
    <p>{`Go to Item Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <p>{`3 Blusterbloom`}</p>
    </Menu>
    <p>{`Exit and head to Conning Creek.`}</p>
    <p>{`Ryu Sands: Kill night battle with Shadow M`}<br parentName="p"></br>{`
`}{`Canalbrine Bridge: Kill 2 land night battles with Shadow M.`}</p>
    <p>{`Northern Conning Creek kill night battle with Shadow M. Then menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Donate BP +Hired Help`}</li>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +`}{`[2]`}{`Grow on Trees`}</li>
        <li parentName="ul">{`Osvald: +`}{`[2]`}{`Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Western Conning Creek kill night battle with Shadow M.`}</p>
    <h3 {...{
      "id": "conning-creek"
    }}>{`Conning Creek`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Rainbow Bottle`}</strong>{`. TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong></p>
    <h3 {...{
      "id": "new-delsta-anchorage-1"
    }}>{`New Delsta: Anchorage`}</h3>
    <p>{`Go to Inventor. Get ASA. Head to Montwise.`}<br parentName="p"></br>{`
`}{`Bolderfall battle kill with Fire M. Pick up `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise"
    }}>{`Montwise`}</h3>
    <p>{`Mug Dazzling Artwork guy (`}<strong parentName="p">{`Thunder`}</strong>{` M)`}</p>
    <p>{`TP `}<strong parentName="p">{`Crackridge Harbor: Anchorage`}</strong>{`.`}</p>
    <h5 {...{
      "id": "crackridge-harbor-anchorage"
    }}>{`Crackridge Harbor: Anchorage`}</h5>
    <p>{`Head towards Merchant Guild. After battle menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <p>{`All: +`}{`[1]`}{`A Step Ahead`}</p>
    </Menu>
    <p>{`Southern Crackridge Wilds: Break encounter and flee. Pick `}<strong parentName="p">{`$6400`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Western Crackridge Wilds: Break encounter and flee. Get `}<strong parentName="p">{`Merchant Guild`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`. Pick `}<strong parentName="p">{`$8500`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "oresrush-2"
    }}>{`Oresrush`}</h3>
    <p>{`Head to `}<strong parentName="p">{`Wellgrove`}</strong>{`.`}</p>
    <h5 {...{
      "id": "northern-wellgrove-trail"
    }}>{`Northern Wellgrove Trail`}</h5>
    <p>{`Pick `}<strong parentName="p">{`Wind M`}</strong>{`. Kill battle with Shadow M + damage on Moose. Pick `}<strong parentName="p">{`Pom L`}</strong>{`.`}</p>
    <h5 {...{
      "id": "eastern-wellgrove-trail"
    }}>{`Eastern Wellgrove Trail`}</h5>
    <p>{`Kill battle with Shadow M + damage on Moose.`}<br parentName="p"></br>{`
`}{`Enter `}<strong parentName="p">{`Wellgrove`}</strong>{`. `}</p>
    <h3 {...{
      "id": "wellgrove"
    }}>{`Wellgrove`}</h3>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h5 {...{
      "id": "montwise-1"
    }}>{`Montwise`}</h5>
    <p>{`Head towards Stormhail.`}<br parentName="p"></br>{`
`}{`Western Montwise Pass: Break with Staff/Sword on front ones, Spear/Axe on Auroch.`}<br parentName="p"></br>{`
`}{`Northern Montwise Pass: HHG x2 unless Big Monkey, then Osvald Attack x2 big one, Pom S Partitio, and Partitio Defend > HHG x4.`}</p>
    <p>{`Southern Stormhail Snows: Reptalios & Snow Leopards HHGx3, others HHG x2`}</p>
    <h3 {...{
      "id": "stormhail"
    }}>{`Stormhail`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Treasured Necklace`}</strong>{` for quest.`}<br parentName="p"></br>{`
`}{`Mug guy in Weapon Shop (Wind M)`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Dazzling Artwork`}</li>
        <li parentName="ul">{`Ogre's Bane`}</li>
        <li parentName="ul">{`Imperial Axe`}</li>
        <li parentName="ul">{`Stimulating Bracelet`}</li>
        <li parentName="ul">{`Thunderstorm Amulet`}</li>
        <li parentName="ul">{`Alluring Ribbon`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Montwise`}</strong>{`.`}</p>
    <h3 {...{
      "id": "montwise-c2"
    }}>{`Montwise (C2)`}</h3>
    <p>{`Purchase `}<strong parentName="p">{`Wind M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`If short for Partitio, do it in menu after Ch.2`}</p>
      </blockquote>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Merchant, +Collect +Donate BP +Hired Help`}</li>
        <li parentName="ul">{`Partitio: +Collect`}</li>
        <li parentName="ul">{`Osvald: `}<strong parentName="li">{`Inventor`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: -`}{`[1]`}{`A Step Ahead +`}{`[1]`}{`Grow on Trees +`}{`[2]`}{`Boost Start`}</li>
        <li parentName="ul">{`Partitio: +`}{`[3]`}{` Boost Start`}</li>
      </ul>
    </Menu>
    <p>{`Challenge 1: Spear x3, Wind M`}<br parentName="p"></br>{`
`}{`Challenge 2: Ice M`}<br parentName="p"></br>{`
`}{`Challenge 3: HHG x2`}<br parentName="p"></br>{`
`}{`Challenge 4: HHG x3`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "bandelam-20000hp-6s-spear-dagger-axe-fire-light"
      }}>{`Bandelam 20000HP 6S (Spear Dagger Axe Fire Light)`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHR x2`}</li>
        <li parentName="ul">{`Osvald: Defend`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: (L) Axe x3`}</li>
        <li parentName="ul">{`Castti: Attack x3`}</li>
        <li parentName="ul">{`Hikari: HHG x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Oresrush`}</strong>{`.`}</p>
    <h3 {...{
      "id": "wellgrove-c3"
    }}>{`Wellgrove (C3)`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equip-skills-3"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: +`}{`[4]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`Wind M & Wind L`}</strong>{`.`}</p>
    <p>{`Kill battle with HHG x2.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$10000`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can get an Allmighty Soulstone from the elemental fight. If you do, you can skip the Thunder M in Castle Mei and use the Allmighty Soulstone on Lord Mugen T1.`}</p>
    </blockquote>
    <p>{`Forced battle HHG x3`}</p>
    <p>{`General Rou: Pom M, Spear x4, HHG x3`}</p>
    <p>{`TP `}<strong parentName="p">{`Stormhail`}</strong></p>
    <h3 {...{
      "id": "stormhail-c4"
    }}>{`Stormhail (C4)`}</h3>
    <p>{`Kunzo: Crit Scope, Merchants Defend. Collect x4 + HHB x4`}<br parentName="p"></br>{`
`}{`Jin Mei: Attack, Attack, Defend, Wild Cut x2, Wild Cut x4`}</p>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`, `}<strong parentName="p">{`$16000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "mei-castle-battles"
    }}>{`Mei Castle Battles`}</h4>
    <p>{`You want to ideally break and flee from these.`}</p>
    <ul>
      <li parentName="ul">{`(15%) `}{`[3]`}{`Clan Mei Spearman x2: Use Sword and Bow to break.`}</li>
      <li parentName="ul">{`(15%) `}{`[2]`}{`War Dog x2, `}{`[3]`}{`Clan Mei Spearman: Axe/Bow on Dogs, Sword/Bow on Spearman`}</li>
      <li parentName="ul">{`(15%) `}{`[4]`}{`Thunder Guardian Mk.II x2: Sword and Bow.`}</li>
      <li parentName="ul">{`(15%) `}{`[2]`}{`Albino Bat x4: Spear, Bow, Staff, Dark. Concoct with Castti?`}</li>
      <li parentName="ul">{`(15%) `}{`[3]`}{`Clan Mei Spearman, `}{`[2]`}{`War Dog, `}{`[1]`}{`Thunder Sentinel Mk.II: Can use any default weapon to break the Sentinel`}</li>
      <li parentName="ul">{`(15%) `}{`[3]`}{`Thunder Curator Mk.II, `}{`[4]`}{`Thunder Guardian Mk.II, `}{`[1]`}{`Thunder Sentinel Mk.II. Merchant breaks Curator`}</li>
      <li parentName="ul">{`(10%) `}{`[2]`}{`Albino Bat x2, `}{`[3]`}{`Frostwing Serpent: Spear/Staff everything, Castti does nothing.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you need money, can pick up `}<strong parentName="p">{`Nightmare Glaive`}</strong>{`. Sells for $9000 with Smooth Talker.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "rai-mei-55000hp-7s-sword-staff-ice-light-36000-collect"
      }}>{`Rai Mei 55000HP 7S (Sword Staff Ice Light) $36000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`M1: HHR x3`}</li>
        <li parentName="ul">{`M2: HHB x3`}</li>
        <li parentName="ul">{`Osvald: Crit Scope Rai Mei`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Lily of the Light x4`}</li>
        <li parentName="ul">{`M1: Pom L M2`}</li>
        <li parentName="ul">{`M2: HHB x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`M1: Collect x2`}</li>
        <li parentName="ul">{`M2: HHG x2`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`You can watch your money when you do HHG x2. Need $68820 to hit $83600 after this fight.`}</p>
      </blockquote>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Wellgrove`}</strong>{`, head to `}<strong parentName="p">{`Ku`}</strong>{`.`}</p>
    <p>{`Eastern Wellgrove Trail: Walk to skip battle.`}<br parentName="p"></br>{`
`}{`Western Sai Sands: Run from battle. Or break with Axe on back guys and Sword on Weed.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Reinforcing Jam`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Eastern Ku Sands: S&Q.`}</p>
    <h3 {...{
      "id": "southern-ku-sands-c5"
    }}>{`Southern Ku Sands (C5)`}</h3>
    <p>{`Buy 2 Forget-me-do. Can skip if drop somewhere and Castti has Latent.`}<br parentName="p"></br>{`
`}{`Need `}<strong parentName="p">{`$83600`}</strong>{`. Can sell Refreshing Jam + Nuts if needed.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ritsu-75000hp-7s-spear-bow-fire-shadow-10000-collect"
      }}>{`Ritsu 75000HP 7S (Spear Bow Fire Shadow) $10000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Spear`}</li>
        <li parentName="ul">{`Partitio: Attack`}</li>
        <li parentName="ul">{`Osvald: Spring Boots Self`}</li>
        <li parentName="ul">{`Castti: `}{`[LP if you have it]`}{` Forget-me-do + Darkdelion x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: E.Bottle x3`}</li>
        <li parentName="ul">{`Hikari: HHR x2`}</li>
        <li parentName="ul">{`Partitio: Donate BP Hikari`}</li>
        <li parentName="ul">{`Castti: Wind M`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
        <li parentName="ul">{`Merchants: HHB x4`}</li>
      </ul>
      <hr></hr>
      <h4 {...{
        "id": "partitio-latent-variation-9s-faster"
      }}>{`Partitio Latent Variation (~9s faster)`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Spear`}</li>
        <li parentName="ul">{`Partitio: Attack x3`}</li>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: `}{`[LP if you have it]`}{` Forget-me-do + Darkdelion x3`}</li>
        <li parentName="ul">{`Osvald: Wind M`}</li>
        <li parentName="ul">{`Hikari: Defend`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` HHR x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Merchants: HHB x4`}</li>
      </ul>
      <hr></hr>
      <h4 {...{
        "id": "partitio-latent-collect-14s-slower-than-no-collect-latent"
      }}>{`Partitio Latent Collect (~14s slower than no Collect Latent)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`This fight requires Hikari Ember`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Ember`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` Collect x4`}</li>
        <li parentName="ul">{`Osvald: Spring Boots Self`}</li>
        <li parentName="ul">{`Castti: `}{`[LP if you have it]`}{` Forget-me-do + Darkdelion`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Elemental Bottle x3`}</li>
        <li parentName="ul">{`Hikari: HHR`}</li>
        <li parentName="ul">{`Partitio: Donate BP Hikari`}</li>
        <li parentName="ul">{`Castti: Wind M`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
        <li parentName="ul">{`Merchants: HHB x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "king-mugen-80000hp-6s-spear-axe-thunder-light-18000-collect"
      }}>{`King Mugen 80000HP 6S (Spear Axe Thunder Light) $18000 Collect`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Thunder M`}</li>
        <li parentName="ul">{`Partitio: Donate BP Hikari`}</li>
        <li parentName="ul">{`Osvald: Spring Boots Castti`}</li>
        <li parentName="ul">{`Castti: Concoct Forget-me-do + Lily of the Light`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Concoct Lily of the Light x4`}</li>
        <li parentName="ul">{`Hikari: HHR x2`}</li>
        <li parentName="ul">{`Partitio: Collect x4`}</li>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Reinforcing Jam Partitio`}</li>
        <li parentName="ul">{`Osvald: L Stone`}</li>
        <li parentName="ul">{`Merchants: HHB x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "hikari-25000hp-7s-sword-axe-light"
      }}>{`"Hikari" 25000HP 7S (Sword Axe Light)`}</h4>
      <ul>
        <li parentName="ul">{`Defend, HHV x4, HHG x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "enshrouded-king-10s-sword-spear-bow-staff-thunder-wind-collect-26000"
      }}>{`Enshrouded King 10S (Sword Spear Bow Staff Thunder Wind) Collect $26000`}</h4>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Hikari: Thunder M`}</li>
        <li parentName="ul">{`Partitio: HHR x3`}</li>
        <li parentName="ul">{`Osvald: Spring Boots Self`}</li>
        <li parentName="ul">{`Castti: Concoct Blusterbloom x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: E.Bottle x3`}</li>
        <li parentName="ul">{`Hikari: Collect x4`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` HHB x3`}</li>
        <li parentName="ul">{`Castti: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Castti: Pom L Hikari`}</li>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
        <li parentName="ul">{`Merchants: HHB x4`}</li>
      </ul>
    </Battle>
    <p>{`End after 5 cutscenes. GG!`}</p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h4 {...{
      "id": "22824"
    }}>{`2/28/24`}</h4>
    <ul>
      <li parentName="ul">{`Fix minor errors`}</li>
    </ul>
    <h4 {...{
      "id": "22424"
    }}>{`2/24/24`}</h4>
    <ul>
      <li parentName="ul">{`Added note on Allmighty Soulstone drop (got it in the relay lol)`}</li>
      <li parentName="ul">{`Added note on how much money you need at Rai Mei HHGx2 to have enough for final bosses.`}</li>
    </ul>
    <h4 {...{
      "id": "22324"
    }}>{`2/23/24`}</h4>
    <ul>
      <li parentName="ul">{`Fix missing stuff from notes (thanks sneaky):`}<ul parentName="li">
          <li parentName="ul">{`Pick Pom L outside Wellgrove`}</li>
          <li parentName="ul">{`HHG x3 on Rou`}</li>
          <li parentName="ul">{`Pick Sai Reinforcing Jam`}</li>
          <li parentName="ul">{`Osvald Crit Scope on Enshrouded`}</li>
        </ul></li>
    </ul>
    <h4 {...{
      "id": "21524"
    }}>{`2/15/24`}</h4>
    <ul>
      <li parentName="ul">{`Added Ritsu no Wind S script, use Double Slash`}</li>
      <li parentName="ul">{`Buy Blusterblooms for new Enshrouded script`}</li>
      <li parentName="ul">{`Change EM grind to start from Oresrush instead of Canalbrine`}</li>
      <li parentName="ul">{`Cut Light M & Shadow M in `}</li>
      <li parentName="ul">{`Change what battles were killed and what were broken. Kill 2 Moose, break all Crackridge and Montwise.`}</li>
      <li parentName="ul">{`Cut Boost Start from Osvald and Castti.`}</li>
      <li parentName="ul">{`Pick Reinforcing Jam in Sai`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      